import React, { useEffect, useState } from "react";
import "./layout.css";
import {
  FaHome,
  FaFutbol,
  FaListUl,
  FaUsers,
  FaLock,
  FaSignOutAlt,
  FaComments,
  FaMoneyCheck,
  FaRegCalendarCheck,
  FaBell,
} from "react-icons/fa";
import { GiTennisCourt } from "react-icons/gi";
import { FaGears, FaGear } from "react-icons/fa6";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
  MdSportsBaseball,
  MdOutlineReportProblem
} from "react-icons/md";
import { AiFillNotification } from "react-icons/ai";
import { TbCloudCog } from "react-icons/tb";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./header";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    if (!auth) {
      navigate("/login");
    }
  }, [auth]);

  if (!auth) {
    return null
  }

  return (
    <div className="dashboard-layout">
      <Header />
      <div className="layout-body">
        <aside className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
          {/* <div className="sidebar-header">
            <h2>{isSidebarOpen ? "Tennis Mate" : "TM"}</h2>
          </div> */}
          <ul className="sidebar-nav">
            {/* <li>
              <button
                onClick={() => setSidebarOpen(!isSidebarOpen)}
                className="toggle-btn"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {isSidebarOpen ? (
                  <MdOutlineArrowBackIos />
                ) : (
                  <MdOutlineArrowForwardIos />
                )}
              </button>
            </li> */}
            <li
              style={{
                backgroundColor: location?.pathname === "/dashboard" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("dashboard")}>
                <FaHome /> {isSidebarOpen && <span>Home</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/courts" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("courts")}>
                <GiTennisCourt /> {isSidebarOpen && <span>Courts</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/sports" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("sports")}>
                <MdSportsBaseball /> {isSidebarOpen && <span>Sports</span>}
              </button>
            </li>
            {/* <li style={{ backgroundColor: location?.pathname == '/game' ? '#34495e' : '' }}>
              <button onClick={() => navigate("game")}>
                <FaListUl /> {isSidebarOpen && <span>Game</span>}
              </button>
            </li> */}
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/user-list" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("user-list")}>
                <FaUsers /> {isSidebarOpen && <span>User List</span>}
              </button>
            </li>
            {/* <li style={{ backgroundColor: location?.pathname == '/bookings' ? '#34495e' : '' }}>
              <button onClick={() => navigate("bookings")}>
                <FaRegCalendarCheck /> {isSidebarOpen && <span>Bookings</span>}
              </button>
            </li> */}
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/push-notifications" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("push-notifications")}>
                <AiFillNotification /> {isSidebarOpen && <span>Push Notifications</span>}
              </button>
            </li>
            {/* <li
              style={{
                backgroundColor:
                  location?.pathname === "/chats" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("chats")}>
                <FaComments /> {isSidebarOpen && <span>Chat</span>}
              </button>
            </li> */}
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/transactions"
                    ? "#34495e"
                    : "",
              }}
            >
              <button onClick={() => navigate("/transactions")}>
                <FaMoneyCheck />{" "}
                {isSidebarOpen && <span>Transactions</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/api-management" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("api-management")}>
                <TbCloudCog /> {isSidebarOpen && <span>API Management</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/change-password" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("change-password")}>
                <FaLock /> {isSidebarOpen && <span>Change Password</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/reports" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("reports")}>
                <MdOutlineReportProblem /> {isSidebarOpen && <span>Reports</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/content-management-system"
                    ? "#34495e"
                    : "",
              }}
            >
              <button onClick={() => navigate("content-management-system")}>
                <FaGears /> {isSidebarOpen && <span>CMS</span>}
              </button>
            </li>
            <li
              style={{
                backgroundColor:
                  location?.pathname === "/settings" ? "#34495e" : "",
              }}
            >
              <button onClick={() => navigate("settings")}>
                <FaGear /> {isSidebarOpen && <span>Settings</span>}
              </button>
            </li>
          </ul>
        </aside>
        <button
          onClick={() => setSidebarOpen(!isSidebarOpen)}
          className="toggle-btn"
          style={{ left: isSidebarOpen ? "235px" : "60px" }}
        >
          {isSidebarOpen ? (
            <MdOutlineArrowBackIos />
          ) : (
            <MdOutlineArrowForwardIos />
          )}
        </button>
        <main
          className="main-content"
          style={{ marginLeft: isSidebarOpen ? "255px" : "80px" }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
